import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogConfirmacaoComponent } from '@components/dialog-confirmacao/dialog-confirmacao.component';

import { ItemVistoriaModelo } from '../../models/item-vistoria-modelo';
import { AtributoItemVistoriaModelo } from '../../models/atributo-item-vistoria-modelo';

@Component({
  selector: 'app-itens-modelo-vistoria',
  standalone: false,
  templateUrl: './itens-modelo-vistoria.component.html',
  styleUrl: './itens-modelo-vistoria.component.scss'
})
export class ItensModeloVistoriaComponent {

  private _itens: ItemVistoriaModelo[] = [];
  private proximoIdTemporario = -1;

  // Setter pra recalcular o próximo id negativo disponível sempre que o array de itens chegar
  // (inclusive do próprio modeloVistoriaVazio(), que já pode vir com um item de exemplo usando
  // um id negativo) — evita colidir com um id negativo que já esteja em uso.
  @Input() set itens(value: ItemVistoriaModelo[]) {
    this._itens = value;
    this.proximoIdTemporario = Math.min(0, ...value.map(i => i.id)) - 1;
  }
  get itens(): ItemVistoriaModelo[] {
    return this._itens;
  }

  @Output() itensChange = new EventEmitter<ItemVistoriaModelo[]>();

  // Avisa o form pai (que também controla os Cômodos) que este item não existe mais no pool,
  // pra remover qualquer vínculo de cômodo que apontava pra ele.
  @Output() itemRemovido = new EventEmitter<ItemVistoriaModelo>();

  constructor(private dialog: MatDialog) { }

  public adicionar(): void {
    const novo: ItemVistoriaModelo = { id: this.proximoIdTemporario--, nome: '', atributos: [] };
    this.itens.push(novo);
    this.emitir();
  }

  public confirmarRemocao(item: ItemVistoriaModelo): void {
    const dialogRef = this.dialog.open(DialogConfirmacaoComponent, {
      width: '467px',
      panelClass: 'no-padding-dialog',
      disableClose: true,
    });
    dialogRef.componentInstance.titulo = 'Remover item de vistoria';
    dialogRef.componentInstance.mensagem = `O item "${item.nome || '-'}" será removido.`;
    dialogRef.componentInstance.textoBtnConfirmacao = 'Remover';
    dialogRef.componentInstance.btnBackgroundColor = '#F44336';
    dialogRef.componentInstance.acaoConfirmacao = () => this.remover(item);
  }

  private remover(item: ItemVistoriaModelo): void {
    this.itens = this.itens.filter(i => i !== item);
    this.emitir();
    this.itemRemovido.emit(item);
  }

  public duplicarItem(item: ItemVistoriaModelo): void {
    const copia: ItemVistoriaModelo = {
      id: this.proximoIdTemporario--,
      nome: `Cópia de ${item.nome}`,
      atributos: item.atributos.map(a => ({ ...a, id: 0 })),
    };
    this.itens.splice(this.itens.indexOf(item) + 1, 0, copia);
    this.emitir();
  }

  public adicionarAtributo(item: ItemVistoriaModelo): void {
    item.atributos.push({
      id: 0, nome: '', ehFoto: false, ordem: 0,
    });
  }

  public removerAtributo(item: ItemVistoriaModelo, atributo: AtributoItemVistoriaModelo): void {
    item.atributos = item.atributos.filter(a => a !== atributo);
  }

  public moverAtributo(item: ItemVistoriaModelo, atributo: AtributoItemVistoriaModelo, delta: number): void {
    const index = item.atributos.indexOf(atributo);
    const novoIndex = index + delta;
    if (novoIndex < 0 || novoIndex >= item.atributos.length) return;
    [item.atributos[index], item.atributos[novoIndex]] = [item.atributos[novoIndex], item.atributos[index]];
  }

  private emitir(): void {
    this.itensChange.emit(this.itens);
  }
}
